import React from 'react'
import TicketList from '../ticket-list'

const Solved = () => (
  <TicketList
    title="Solved Tickets List"
    statusFilter="Resolved"
    editableStatuses={[]} 
    displayStatus={(s) => (s === 'Resolved' ? 'Solved' : s)}
  />
)

export default Solved
